import { render, staticRenderFns } from "./InventoryPurchasingModal.vue?vue&type=template&id=5877fa60&"
import script from "./InventoryPurchasingModal.vue?vue&type=script&lang=js&"
export * from "./InventoryPurchasingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports